import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { P6SyncResult } from '../../../models/integration.model';
import { TranslocoService } from '@ngneat/transloco';

/**
 * P6 Sync Results Modal Component
 * Displays detailed results of P6 synchronization operations
 * Type-safe handling of P6-specific result data
 */
@Component({
  selector: 'app-p6-sync-results-modal',
  templateUrl: './p6-sync-results-modal.component.html',
  styleUrls: ['./p6-sync-results-modal.component.scss'],
})
export class P6SyncResultsModalComponent implements OnInit {
  // Public properties
  syncResult: P6SyncResult;

  constructor(
    public dialogRef: MatDialogRef<P6SyncResultsModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { syncResult: P6SyncResult },
    private transloco: TranslocoService,
  ) {
    this.syncResult = data.syncResult;
  }

  // -----------------------------------------------------------------------------------------------------
  // @ Lifecycle hooks
  // -----------------------------------------------------------------------------------------------------

  ngOnInit(): void {
    console.log('P6 Sync Results Modal initialized with result:', this.syncResult);
  }

  // -----------------------------------------------------------------------------------------------------
  // @ Public methods
  // -----------------------------------------------------------------------------------------------------

  /**
   * Check if sync was successful
   */
  isSuccessful(): boolean {
    return this.syncResult.status === 'success' || this.syncResult.status === 'completed';
  }

  /**
   * Check if there are failed reports
   */
  hasFailedReports(): boolean {
    return this.syncResult.failed_p6_reports?.length > 0;
  }

  /**
   * Format timestamp for display
   */
  formatTimestamp(timestamp: string): string {
    return new Date(timestamp).toLocaleString();
  }

  /**
   * Get success rate percentage
   */
  getSuccessRate(): number {
    return this.syncResult.summary?.success_rate || 0;
  }

  /**
   * Close the modal
   */
  onClose(): void {
    this.dialogRef.close(false);
  }

  /**
   * Refresh P6 data
   */
  onRefreshP6Data(): void {
    this.dialogRef.close(true);
  }
}
